'use client';

import { Skeleton } from '@mui/material';

import styles from './DataBadge.module.scss';

import type { ReactNode } from 'react';

export type DataBadgeVariant =
  | 'default'
  | 'success'
  | 'info'
  | 'destructive'
  | 'warning';

type DataBadgeProps = {
  title: ReactNode;
  value: ReactNode;
  description?: ReactNode;
  variant?: DataBadgeVariant;
  isLoading?: boolean;
  className?: string;
};

export function DataBadge({
  title,
  value,
  description,
  variant = 'default',
  isLoading = false,
  className,
}: DataBadgeProps) {
  return (
    <section
      className={[styles.dataBadge, styles[variant], className]
        .filter(Boolean)
        .join(' ')}
    >
      {isLoading ? (
        <>
          <Skeleton variant="text" width="55%" height={16} />
          <Skeleton variant="text" width="70%" height={36} />
          <Skeleton variant="text" width="85%" height={16} />
        </>
      ) : (
        <>
          <div className={styles.title}>{title}</div>
          <div className={styles.value}>{value}</div>
          {description ? (
            <div className={styles.description}>{description}</div>
          ) : null}
        </>
      )}
    </section>
  );
}
